/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconDenglu1: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M994.047036 1024H29.952964a30.10554 30.10554 0 0 1-23.193554-10.854378 29.337541 29.337541 0 0 1-6.143987-24.627151l47.871904-233.369133a173.618853 173.618853 0 0 1 60.979078-99.839801 177.510045 177.510045 0 0 1 111.206178-39.167921h134.246131c4.249592 0 8.499183 0.921598 12.390375 2.662394a353.688893 353.688893 0 0 0 145.919709 31.078338c50.841498 0 99.891-10.444779 145.817308-31.078338a30.310339 30.310339 0 0 1 12.441575-2.662394h131.839736c40.447919 0 79.87184 13.926372 111.206178 39.167921a173.567653 173.567653 0 0 1 60.927878 99.839801l47.923104 233.369133a29.337541 29.337541 0 0 1-6.143987 24.575951 30.10554 30.10554 0 0 1-23.193554 10.905578zM66.663291 964.812918h890.724618l-40.652718-197.887604a115.711769 115.711769 0 0 0-113.356574-91.596617H677.887668a413.695173 413.695173 0 0 1-164.65887 33.791933c-57.292685 0-112.639775-11.366377-164.658871-33.791933H220.672583a115.711769 115.711769 0 0 0-113.407774 91.596617l-40.601518 197.887604z m446.565507-361.727276a305.304989 305.304989 0 0 1-215.909969-88.319824A297.727405 297.727405 0 0 1 207.872608 301.569445c0-80.537439 31.743937-156.262087 89.446221-213.247574A305.304989 305.304989 0 0 1 513.228798 0.002048c81.510237 0 158.207684 31.385537 215.858768 88.319823a297.727405 297.727405 0 0 1 89.446221 213.247574c0 80.537439-31.743937 156.262087-89.446221 213.196373a305.304989 305.304989 0 0 1-215.858768 88.319824z m0-543.896512C377.856268 59.18913 267.776488 167.937712 267.776488 301.569445s110.07978 242.329115 245.40111 242.329115c135.270129 0 245.349909-108.697383 245.349909-242.329115 0-133.631733-110.07978-242.380315-245.349909-242.380315z"
        fill={getIconColor(color, 0, '#FFFFFF')}
      />
    </svg>
  );
};

IconDenglu1.defaultProps = {
  size: 18,
};

export default IconDenglu1;
